import clickOutside from '../helpers/click-outside';
let helpTriggerAll = document.querySelectorAll(".help-trigger");
let helpTrigger = document.querySelector(".help-trigger");
var i;
try{
    for (i = 0; i < helpTriggerAll.length; i++) {
        helpTriggerAll[i].addEventListener("click", (e) => {
            var help = document.querySelector(".help");
            if ( help !== null ) {
                if(!help.classList.contains("open")){
                    help.classList.add("open");
                } else {
                    help.classList.remove("open");
                }
            }
        });
    }
} catch(error){}
document.addEventListener('click', (e) => {
    if (e.target.closest('.help.open') === null && !e.target.classList.contains("help-trigger")) {
        var dropdownOpen = document.querySelector('.help.open');
        if (dropdownOpen) {
            document.querySelector('.help').classList.remove("open");
        }
    }
});


// WEBPACK FOOTER //
// ./scripts/components/help.js